export interface FlatMapPop {
  city: string;
  country: string;
  lat: number;
  lng: number;
  tier: 0 | 1 | 2 | 3;
  home?: boolean;
}

export const FLAT_MAP_DOT_GREEN = '#9CFF2E';
export const FLAT_MAP_DOT_BLUE = '#4ED7FF';

export const FLAT_MAP_LAND_URLS = ['https://cdn.jsdelivr.net/npm/world-atlas@2/land-110m.json', 'https://unpkg.com/world-atlas@2/land-110m.json'];

export const FLAT_MAP_COUNTRY_URLS = ['https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json', 'https://unpkg.com/world-atlas@2/countries-110m.json'];

export const FLAT_MAP_FALLBACK_LAND: number[][][] = [
  [
    [-168, 66],
    [-156, 71],
    [-140, 70],
    [-125, 60],
    [-122, 49],
    [-124, 40],
    [-118, 33],
    [-104, 28],
    [-97, 26],
    [-88, 30],
    [-80, 25],
    [-77, 35],
    [-72, 41],
    [-66, 45],
    [-57, 50],
    [-65, 57],
    [-78, 63],
    [-95, 60],
    [-110, 70],
    [-130, 73],
    [-158, 72],
  ],
  [
    [-108, 25],
    [-95, 18],
    [-85, 15],
    [-78, 9],
    [-82, 8],
    [-90, 14],
    [-100, 17],
    [-108, 25],
  ],
  [
    [-80, 12],
    [-73, 11],
    [-65, 10],
    [-52, 4],
    [-48, -2],
    [-40, -5],
    [-35, -8],
    [-37, -15],
    [-39, -22],
    [-48, -25],
    [-55, -33],
    [-65, -40],
    [-70, -53],
    [-72, -52],
    [-72, -42],
    [-75, -30],
    [-80, -12],
    [-80, -4],
    [-79, 2],
    [-77, 7],
    [-80, 12],
  ],
  [
    [-10, 37],
    [-5, 43],
    [0, 48],
    [4, 51],
    [9, 54],
    [13, 55],
    [18, 58],
    [22, 66],
    [25, 69],
    [20, 70],
    [10, 65],
    [5, 60],
    [-3, 58],
    [-6, 55],
    [-10, 52],
    [-10, 45],
    [-10, 37],
  ],
  [
    [-17, 21],
    [-12, 14],
    [-5, 5],
    [6, 4],
    [9, 0],
    [13, -5],
    [18, -12],
    [20, -25],
    [23, -34],
    [28, -33],
    [33, -26],
    [40, -15],
    [44, -3],
    [50, 9],
    [48, 12],
    [42, 14],
    [38, 18],
    [32, 23],
    [25, 30],
    [15, 32],
    [5, 33],
    [-6, 32],
    [-12, 27],
    [-17, 21],
  ],
  [
    [26, 30],
    [32, 30],
    [40, 25],
    [48, 28],
    [55, 25],
    [60, 28],
    [55, 35],
    [45, 38],
    [38, 36],
    [30, 35],
    [26, 30],
  ],
  [
    [25, 57],
    [40, 60],
    [60, 62],
    [80, 66],
    [100, 70],
    [120, 72],
    [140, 72],
    [155, 68],
    [170, 66],
    [178, 66],
    [178, 72],
    [160, 74],
    [140, 76],
    [120, 76],
    [95, 77],
    [70, 74],
    [45, 72],
    [30, 68],
    [25, 57],
  ],
  [
    [68, 22],
    [72, 24],
    [78, 30],
    [85, 28],
    [92, 25],
    [95, 22],
    [97, 16],
    [92, 12],
    [85, 8],
    [80, 6],
    [75, 8],
    [72, 15],
    [68, 22],
  ],
  [
    [80, 45],
    [95, 45],
    [110, 42],
    [122, 40],
    [128, 38],
    [130, 30],
    [122, 25],
    [115, 22],
    [108, 20],
    [100, 22],
    [95, 28],
    [85, 35],
    [80, 45],
  ],
  [
    [130, 34],
    [136, 35],
    [141, 38],
    [144, 42],
    [141, 44],
    [138, 40],
    [134, 36],
    [130, 34],
  ],
  [
    [95, 5],
    [105, 3],
    [115, 0],
    [125, -3],
    [135, -5],
    [140, -4],
    [135, -8],
    [120, -9],
    [105, -8],
    [95, -6],
    [95, 5],
  ],
  [
    [113, -22],
    [122, -18],
    [130, -13],
    [140, -12],
    [145, -15],
    [150, -24],
    [148, -36],
    [138, -38],
    [128, -33],
    [118, -33],
    [113, -30],
    [113, -22],
  ],
  [
    [166, -46],
    [173, -41],
    [178, -38],
    [176, -41],
    [171, -45],
    [166, -46],
  ],
  [
    [-50, 60],
    [-40, 63],
    [-25, 70],
    [-20, 80],
    [-30, 83],
    [-45, 80],
    [-55, 75],
    [-55, 65],
    [-50, 60],
  ],
  [
    [43, -12],
    [48, -15],
    [50, -22],
    [47, -25],
    [44, -22],
    [43, -12],
  ],
  [
    [-6, 50],
    [-3, 52],
    [-2, 55],
    [-4, 58],
    [-7, 57],
    [-8, 54],
    [-6, 50],
  ],
];
